import { render } from "./EmailBrandingListings.vue?vue&type=template&id=799798bc&scoped=true&ts=true"
import script from "./EmailBrandingListings.vue?vue&type=script&lang=ts"
export * from "./EmailBrandingListings.vue?vue&type=script&lang=ts"

import "./EmailBrandingListings.vue?vue&type=style&index=0&id=799798bc&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799798bc"]])

export default __exports__